// Styles
import './VBtnToggle.sass'

// Mixins
import ButtonGroup from '../../mixins/button-group'
import Colorable from '../../mixins/colorable'

// Utilities
import mixins from '../../util/mixins'

/* @vue/component */
export default mixins(
  ButtonGroup,
  Colorable
).extend({
  name: 'v-btn-toggle',

  props: {
    backgroundColor: String,
    borderless: Boolean,
    dense: Boolean,
    group: Boolean,
    rounded: Boolean,
    shaped: Boolean,
    tile: Boolean,
    classPrefix: {
      type: String,
      default: '',
    },
  },

  computed: {
    classes (): object {
      return {
        ...ButtonGroup.options.computed.classes.call(this),
        [`${this.classPrefix}v-btn-toggle`]: true,
        [`${this.classPrefix}v-btn-toggle--borderless`]: this.borderless,
        [`${this.classPrefix}v-btn-toggle--dense`]: this.dense,
        [`${this.classPrefix}v-btn-toggle--group`]: this.group,
        [`${this.classPrefix}v-btn-toggle--rounded`]: this.rounded,
        [`${this.classPrefix}v-btn-toggle--shaped`]: this.shaped,
        [`${this.classPrefix}v-btn-toggle--tile`]: this.tile,
        ...this.themeClasses,
      }
    },
  },

  methods: {
    genData () {
      const data = this.setTextColor(this.color, {
        ...ButtonGroup.options.methods.genData.call(this),
      })

      if (this.group) return data

      return this.setBackgroundColor(this.backgroundColor, data)
    },
  },
})
